var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-page',{staticClass:"iframe-page"},[(_vm.iframeUrl)?_c('iframe',{staticClass:"full-iframe",attrs:{"src":_vm.iframeUrl},on:{"load":_vm.onIframeLoad}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }